import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { List } from '@alfa-bank/site-lists';
import { ModalDesktop as Modal } from '@alfa-bank/site-modal/desktop';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';

import type { TChangingAddressDesktop, IDepsDesktop } from '../model';

import { ChangingAddressDesktop as Component } from './changing-address';

export const ChangingAddressDesktop = createWidget<IDepsDesktop, TChangingAddressDesktop>({
    Button,
    List,
    Text,
    Modal,
})(Component);
